//Styles
import { useDraggable } from "@dnd-kit/core"

export default function Draggable({ id, data, children, disabled }) {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: id,
    data: data,
  })

  if (disabled) {
    return <div>{children}</div>
  } else {
    return (
      <div ref={setNodeRef} {...attributes} {...listeners}>
        {children}
      </div>
    )
  }
}
